module.exports = __webpack_public_path__ + "img/マイナンバー.dc248fd1.png";